module.exports = __webpack_public_path__ + "img/tes-new-pdf-logo.1ec178b0.jpg";